<div
  class="drop-zone-container"
  [class.dragging]="isDragging$ | async"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)">
  <ng-content></ng-content>
  <div class="drop-overlay" *ngIf="isDragging$ | async">
    <ng-container *ngFor="let type of types">
      <ngx-file-drop (onFileDrop)="onFileDropped($event, type)" class="drop-box">
        <ng-template ngx-file-drop-content-tmp>
          <div class="drop-inner">
            <p>{{ type }}</p>
          </div>
        </ng-template>
      </ngx-file-drop>
    </ng-container>
  </div>
  <ng-template #template let-toastRef>
    <div class="toast-container">
      Attaching {{ toastRef?.data?.name }}
      <button mat-button class="toast-cancel-button" (click)="toastRef.close({ dismissedByAction: true })">CANCEL</button>
    </div>
   </ng-template>
</div>
